import withShow from "@common/withShow";
import { Button } from "@components/index";
import { useSafeNavigate } from "@routes/hooks/useSafeNavigate";
import type React from "react";

type Props = {
  close: () => void;
};

const HeaderButtonProcesses: React.FC<Props> = ({ close }) => {
  const navigate = useSafeNavigate();

  const goTo = () => void navigate("/processes");

  return (
    <Button
      blockedWidth
      size="lg"
      content="start"
      buttonStyle="tertiary"
      icon="list"
      label="Processos"
      onClick={() => {
        close();
        goTo();
      }}
    />
  );
};

export default withShow(HeaderButtonProcesses);
